import React from 'react'
import { Link } from 'react-router-dom'
import { Facebook, Instagram, Envelope, Discord } from 'react-bootstrap-icons'

import borders from '../../img/borders_heraldry_png.png'
import strathclyde from '../../img/strathclydelogo.png'
import falkirk from '../../img/falkirk_heraldry_png.png'
import dundee from '../../img/dundee_heraldry.png'
import edinburgh from '../../img/edinburgh_heraldry_png_2.png'




const Groups = () => {


  return (
    <>
    {/*
      <LoadScript
      googleMapsApiKey="AIzaSyCka3XVifIeG0eCOOfmWqiDu4bwb0uyZ7k"
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={8}
      >
   

        <></>
      </GoogleMap>
    </LoadScript>
    */}
       <header className=" flex flex-wrap ">
        <div className="hero2 flex flex-col items-center w-full py-40">
            <h1 className="text-2xl font-bold leading-snug tracking-tight text-gray-300 lg:text-3xl lg:leading-tight xl:text-3xl xl:leading-tight ">
              Our Groups
            </h1>
        </div>
      </header>


      <section className='md:w-3/4 m-auto '>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 my-10">
        <div className="bg-white shadow rounded-lg p-4 flex flex-col h-full text-left">
                <img className="h-32 w-auto object-contain mx-auto mb-4 drop-shadow-md" src={edinburgh} alt="Edinburgh Group Logo"   />
                <h2 className='text-2xl text-center pb-6'>Edinburgh</h2>
                <p><b>Meeting Times:</b></p>
                <p>Saturday 12:00 - 17:00  (except shows)</p>
                <p><b>Location:</b> Craigmillar Castle, Craigmillar Castle Road, Edinburgh, EH16 4SY</p>    
                <p><b>Get in touch:</b></p>
                <div className='flex gap-4 pt-4 justify-center md:justify-start'>
                    <Link to="https://www.facebook.com/EdinburghBXIV "><Facebook className='text-2xl text-gray-800'/></Link>
                    <Link to="https://www.instagram.com/bxiv.edinburgh/"><Instagram className='text-2xl text-gray-800'/></Link>
                    <a href="mailto:BXIV.Edinburgh@gmail.com"><Envelope className='text-2xl text-gray-800'/></a>
                </div>
            </div>

  <div className="bg-white shadow rounded-lg p-4 flex flex-col h-full text-left">
                <img className="h-32 w-auto object-contain mx-auto mb-4 drop-shadow-md" src={strathclyde} alt="Strathclyde Medieval Society Heraldry" />
                <h2 className='text-2xl text-center pb-6'>Strathclyde</h2>
                <p><b>Meeting Times:</b></p>
                <p>Saturday 12:00 - 16:00 (except shows)</p>
                <p><b>Location:</b> Bothwell Castle, Uddingston, Bothwell, Glasgow G71 8BL</p> 
                <p><b>Get in touch:</b></p>
                <div className='flex gap-4  pt-4  justify-center md:justify-start'>
                    <Link to="https://discord.gg/VfMDexs4jD"><Discord className='text-2xl text-gray-800'/></Link>
                    <Link to="https://www.instagram.com/bxiv.strathclyde/"><Instagram className='text-2xl text-gray-800'/></Link>

                </div>
            </div>

  <div className="bg-white shadow rounded-lg p-4 flex flex-col h-full text-left">
                <img className="h-32 w-auto object-contain mx-auto mb-4 drop-shadow-md" src={falkirk} alt="Falkirk Group logo" />
                <h2 className='text-2xl text-center pb-6'>Falkirk</h2>
                <p><b>Meeting Times:</b></p>
                <p>Saturday 12:00 - 16:00 (except shows)</p>
                <p><b>Location:</b> Kinneil Estate, Bo'ness, EH51 0PJ </p> 
                <br />
                <p><b>Get in touch:</b></p>
                <div className='flex gap-4  pt-4 justify-center md:justify-start'>
                    <Link to="https://www.facebook.com/groups/813827825800109/?ref=share"><Facebook className='text-2xl text-gray-800'/></Link>
      
                </div>
            </div>

  <div className="bg-white shadow rounded-lg p-4 flex flex-col h-full text-left">
                <img className="h-32 w-auto object-contain mx-auto mb-4 drop-shadow-md"  src={borders} alt="Borders Group Heraldry" />
                <h2 className='text-2xl text-center pb-6'>Borders</h2>
                <p><b>Meeting Times:</b></p>
                <p>Saturday 12:00 - 17:00 (except shows)</p>
                <p><b>Location:</b> Harmony Orchard (Opposite Harmony Garden), St Mary's Rd, Melrose ,TD6 9LJ</p> 
                <p><b>Get in touch:</b></p>
                <div className='flex gap-4  pt-4 justify-center md:justify-start'>
                    <Link to="https://www.facebook.com/groups/392640405472337"><Facebook className='text-2xl text-gray-800'/></Link>
             
                </div>
            </div>

  <div className="bg-white shadow rounded-lg p-4 flex flex-col h-full text-left">
                <img className="h-32 w-auto object-contain mx-auto mb-4 drop-shadow-md" src={dundee} alt="Dundee Medieval Society Heraldry" />
                <h2 className='text-2xl text-center pb-6'>Dundee</h2>
                <p><b>Meeting Times:</b></p>
                <p>Saturday 12:00-16:00</p>
                <p><b>Location:</b>Lochee Park (near the Ancrum Road entrance), Dundee DD2 2HN</p> 
                <p><b>Get in touch:</b></p>
                 <div className='flex gap-4  pt-4 justify-center md:justify-start'>
                 <Link to="https://www.facebook.com/profile.php?id=61574667406112"><Facebook className='text-2xl text-gray-800'/></Link>
              
            </div>
            </div>
        </div>

      </section>

      <div style={{width: "100%", overflow: "hidden", height: "500px"}}>
        <iframe src="https://www.google.com/maps/d/embed?mid=1gDIFdhxr9BYXy5ZFjn5_xMrgs43_4Rs&ehbc=2E312F" width="100%" height="700" style={{marginTop : "0"}}></iframe>

      </div>
    </>
  )
}

export default Groups